import React, { useEffect, useState } from "react";
import BreadcrumbStyle2 from "../components/Breadcrumb/BreadcrumbStyle2";
import Section from "../components/Section";
import BannerSectionStyle9 from "../components/Section/BannerSection/BannerSectionStyle9";
import DoctorDetailsSection from "../components/Section/DoctorDetailsSection";
import AppointmentSectionStyle2 from "../components/Section/AppointmentSection/AppointmentSectionStyle2";
import { pageTitle } from "../helpers/PageTitle";
import axiosInstance from "../utils/axiosInstance";
import { fetchDoctorProfile, imageBaseUrl } from "../constants/ApiConstants";
import { useParams } from "react-router-dom";
import DoctorProfileLoading from "../components/Section/DoctorDetailsSection/comps/DoctorProfileLoading";

export default function DoctorDetails() {
  pageTitle("Doctor Details");
  const id = useParams().doctorId;
  const [doctorDetail, setDoctorDetail] = useState("");
  const [doctorId, setDoctorId] = useState(id);
  const [loading, setLoading] = useState(false);

  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDoctorDetail();
  }, [id]);
  return (
    <>
      <BreadcrumbStyle2 />

      <Section bottomMd={190} bottomLg={150} bottomXl={110}>
        {loading && <DoctorProfileLoading />}
        {!loading && doctorDetail && (
          <DoctorDetailsSection
            imgUrl={`${imageBaseUrl}${doctorDetail.image}`}
            name={doctorDetail.name}
            designation={doctorDetail.designation}
            description={doctorDetail.about_youself}
            languages={doctorDetail.languages_spoken}
            awards={doctorDetail?.awards}
            experience={doctorDetail.experience}
            {...doctorDetail}
          />
        )}
      </Section>
    </>
  );
}
